import React, { useContext } from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoutes from "../components/ProtectedRoutes/protectedRoutes";
import DashboardPage from "../pages/Dashboard/dashboard";
import Error404Page from "../pages/Error404/error404";
import LoginPage from "../pages/Login/login";
import RegisterLogin from "../pages/Register/register";
import { DadosUsuarioContext } from "../providers/DadosDoUsuario";

export const RoutesMain = () => {
  const { usuario, setUsuario } = useContext(DadosUsuarioContext);

  return (
    <Routes>
      <Route path="/" element={<LoginPage setUsuario={setUsuario} />} />

      <Route path="/register" element={<RegisterLogin />} />

      <Route path="*" element={<Error404Page />} />

      <Route element={<ProtectedRoutes />}>
        <Route
          path="/dashboard"
          element={<DashboardPage usuario={usuario} />}
        />
      </Route>
    </Routes>
  );
};
